import { Grid2, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function ErrorState({ errorMessage }: { errorMessage: string }) {
    return <Grid2 sx={{
        background: '#FFFFFF0D',
        padding: 2,
        borderRadius: 4,
        textAlign: 'center',
    }}>
        <ErrorOutlineIcon htmlColor='var(--text-primary)' />
        <Typography variant='h6'>
            {errorMessage}
        </Typography>
    </Grid2>
}
